import { render, staticRenderFns } from "./public.vue?vue&type=template&id=beeb44ec&scoped=true&"
import script from "./public.vue?vue&type=script&lang=js&"
export * from "./public.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeb44ec",
  null
  
)

export default component.exports